/**
 * Utilitaires pour calculer les distances entre adresses
 */

// Fonction pour calculer la distance à vol d'oiseau entre deux points GPS
export const calculateDistanceAsTheCrowFlies = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Rayon de la Terre en kilomètres
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const distance = R * c;
  return Math.round(distance * 100) / 100; // Arrondir à 2 décimales
};

// Fonction pour calculer la distance routière entre deux adresses
export const calculateRoadDistance = async (fromCoordinates, toCoordinates) => {
  try {
    // Utiliser l'API de routage gratuite OSRM (OpenStreetMap Routing Machine)
    const [fromLon, fromLat] = fromCoordinates;
    const [toLon, toLat] = toCoordinates;
    
    const response = await fetch(
      `https://router.project-osrm.org/route/v1/driving/${fromLon},${fromLat};${toLon},${toLat}?overview=false&steps=false`
    );
    
    if (response.ok) {
      const data = await response.json();
      if (data.routes && data.routes.length > 0) {
        const distanceInMeters = data.routes[0].distance;
        const distanceInKm = Math.round((distanceInMeters / 1000) * 100) / 100;
        const durationInSeconds = data.routes[0].duration;
        
        return {
          distance: distanceInKm,
          duration: Math.round(durationInSeconds / 60), // en minutes
          success: true
        };
      }
    }
    
    // Fallback sur la distance à vol d'oiseau avec un coefficient multiplicateur
    const crowFliesDistance = calculateDistanceAsTheCrowFlies(fromLat, fromLon, toLat, toLon);
    const estimatedRoadDistance = Math.round(crowFliesDistance * 1.3 * 100) / 100; // +30% pour les détours
    
    return {
      distance: estimatedRoadDistance,
      duration: Math.round(estimatedRoadDistance * 2), // Estimation : 30 km/h moyenne
      success: false,
      fallback: true
    };
    
  } catch (error) {
    console.error('Erreur calcul distance routière:', error);
    
    // Fallback sur la distance à vol d'oiseau
    const [fromLon, fromLat] = fromCoordinates;
    const [toLon, toLat] = toCoordinates;
    const crowFliesDistance = calculateDistanceAsTheCrowFlies(fromLat, fromLon, toLat, toLon);
    const estimatedRoadDistance = Math.round(crowFliesDistance * 1.3 * 100) / 100;
    
    return {
      distance: estimatedRoadDistance,
      duration: Math.round(estimatedRoadDistance * 2),
      success: false,
      fallback: true,
      error: error.message
    };
  }
};

// Fonction pour valider des coordonnées GPS
export const isValidCoordinates = (coordinates) => {
  if (!Array.isArray(coordinates) || coordinates.length !== 2) {
    return false;
  }
  
  const [lon, lat] = coordinates;
  return (
    typeof lon === 'number' && 
    typeof lat === 'number' &&
    lon >= -180 && lon <= 180 &&
    lat >= -90 && lat <= 90
  );
};

// Fonction pour formater la distance pour l'affichage
export const formatDistance = (distance) => {
  if (distance < 1) {
    return `${Math.round(distance * 1000)} m`;
  } else if (distance < 10) {
    return `${distance.toFixed(1)} km`;
  } else {
    return `${Math.round(distance)} km`;
  }
};

// Fonction pour formater la durée pour l'affichage
export const formatDuration = (minutes) => {
  if (minutes < 60) {
    return `${minutes} min`;
  } else {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (remainingMinutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h${remainingMinutes.toString().padStart(2, '0')}`;
    }
  }
};
